var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'no-background': _vm.path === 'softIntroduction'},style:({'overflow-y': _vm.overflow}),attrs:{"id":"app"}},[(!(_vm.path === 'softIntroduction' || _vm.path === 'wh5' || _vm.path == 'iframePay'))?_c('Layout'):_vm._e(),((_vm.path === 'softIntroduction' || _vm.path === 'wh5' || _vm.path == 'iframePay'))?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }